var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4L20 20C20 21.105 19.105 22 18 22L6 22C4.895 22 4 21.105 4 20L4 4C4 2.895 4.895 2 6 2L18 2C19.105 2 20 2.895 20 4ZM8.5 13.5L15.5 13.5C15.776 13.5 16 13.276 16 13L16 12.5C16 12.224 15.776 12 15.5 12L8.5 12C8.224 12 8 12.224 8 12.5L8 13C8 13.276 8.224 13.5 8.5 13.5ZM7.5 18C7.224 18 7 17.776 7 17.5L7 16.5C7 16.224 7.224 16 7.5 16L8.5 16C8.776 16 9 16.224 9 16.5L9 17.5C9 17.776 8.776 18 8.5 18L7.5 18ZM11.5 18L12.5 18C12.776 18 13 17.776 13 17.5L13 16.5C13 16.224 12.776 16 12.5 16L11.5 16C11.224 16 11 16.224 11 16.5L11 17.5C11 17.776 11.224 18 11.5 18ZM15.5 18C15.224 18 15 17.776 15 17.5L15 16.5C15 16.224 15.224 16 15.5 16L16.5 16C16.776 16 17 16.224 17 16.5L17 17.5C17 17.776 16.776 18 16.5 18L15.5 18ZM12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon);
export default __webpack_public_path__ + "static/media/Card icon.ef0c76089834ff65cde98320be374422.svg";
export { ForwardRef as ReactComponent };